export default __webpack_public_path__ + "static/media/tiktok-icon-card.371b0b8c.svg";